import React, { Component } from 'react';
import styles from './HomePage.module.scss';
import { ReactComponent as LandingSyncSvg } from '../../resources/images/landing-sync.svg';
import { ReactComponent as LandingSetupSvg } from '../../resources/images/landing-setup.svg';
import { ReactComponent as LandingReportsSvg } from '../../resources/images/landing-reports.svg';
import { ReactComponent as LandingAdminSvg } from '../../resources/images/landing-admin.svg';
import LayoutComponent from '../../components/LayoutComponent/LayoutComponent';
import Icon from '@ant-design/icons';
import CustomContext from '../../context/CustomContext';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import PlatformConnectionModal from './PlatformConnectionModal/PlatformConnectionModal';
import { workDocsOAuth2Enabled } from '../../api/CustomAxios';

class HomePage extends Component<Props> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    /*** COMPONENTS ***/

    render() {
        const { auth } = this.context;

        return (
            <>
                <LayoutComponent pageId="home">
                    <Row justify="center" align="stretch" gutter={52} wrap>
                        <Col xs={24} md={12} lg={6}>
                            <Link to={auth?.authorities.includes('ROLE_SYNC') ? '/sync' : '#'}>
                                <div
                                    className={`${styles.application} ${
                                        auth?.authorities.includes('ROLE_SYNC') ? styles.enabled : styles.disabled
                                    }`}
                                >
                                    <Icon component={LandingSyncSvg} className={styles.image} />
                                    <p className={styles.title}>
                                        <FormattedMessage id="home.sync" />
                                    </p>
                                    <p className={styles.description}>
                                        <FormattedMessage id="home.sync.description" />
                                    </p>
                                </div>
                            </Link>
                        </Col>
                        <Col xs={24} md={12} lg={6}>
                            <Link to={auth?.authorities.includes('ROLE_SETUP') ? '/setup' : '#'}>
                                <div
                                    className={`${styles.application} ${
                                        auth?.authorities.includes('ROLE_SETUP') ? styles.enabled : styles.disabled
                                    }`}
                                >
                                    <Icon component={LandingSetupSvg} className={styles.image} />
                                    <p className={styles.title}>
                                        <FormattedMessage id="home.setup" />
                                    </p>
                                    <p className={styles.description}>
                                        <FormattedMessage id="home.setup.description" />
                                    </p>
                                </div>
                            </Link>
                        </Col>
                        <Col xs={24} md={12} lg={6}>
                            <Link to={auth?.authorities.includes('ROLE_REPORTS') ? '#' : '#'}>
                                <div
                                    className={`${styles.application} ${
                                        auth?.authorities.includes('ROLE_REPORTS') ? styles.disabled : styles.disabled
                                    }`}
                                >
                                    <Icon component={LandingReportsSvg} className={styles.image} />
                                    <p className={styles.title}>
                                        <FormattedMessage id="home.reports" />
                                    </p>
                                    <p className={styles.description}>
                                        <FormattedMessage id="home.reports.description" />
                                    </p>
                                </div>
                            </Link>
                        </Col>
                        <Col xs={24} md={12} lg={6}>
                            <Link to={auth?.authorities.includes('ROLE_ADMIN') ? '/admin' : '#'}>
                                <div
                                    className={`${styles.application} ${
                                        auth?.authorities.includes('ROLE_ADMIN') ? styles.enabled : styles.disabled
                                    }`}
                                >
                                    <Icon component={LandingAdminSvg} className={styles.image} />
                                    <p className={styles.title}>
                                        <FormattedMessage id="home.admin" />
                                    </p>
                                    <p className={styles.description}>
                                        <FormattedMessage id="home.admin.description" />
                                    </p>
                                </div>
                            </Link>
                        </Col>
                    </Row>
                </LayoutComponent>
                {workDocsOAuth2Enabled && <PlatformConnectionModal />}
            </>
        );
    }
}
export default injectIntl(HomePage);

interface Props extends WrappedComponentProps {}
